
import { text } from '@fortawesome/fontawesome-svg-core';

export default {
  name: 'ProductKeyItem',

  props: {
    tickCrossValue: {
      required: false,
      default: '',
    },
    originalValue: {
      type: String,
      required: false,
      default: '',
    },
    alignFormat: {
      type: String,
      required: false,
      default: 'center',
      // options:
      // flex-start
      // center
      // flex-end
    },
    tooltipContent: {
      type: String,
      required: false,
      default: '',
    },
    showKeyDropdownArrow: {
      type: Boolean,
      default: false,
      required: false,
    },
    showValueDropdownArrow: {
      type: Boolean,
      default: false,
      required: false,
    },
    mode: {
      type: String,
      required: false,
      default: 'default',
    },
    negative: {
      type: Boolean,
      default: false,
      required: false,
    },
    textBold: {
      type: Boolean,
      default: false,
      required: false
    },
    isFirstChild: {
      type: Boolean,
      required: false,
      default: true,
    },
    isTextBlack: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTextBold: {
      type: Boolean,
      required: false,
      default: false,
    },
    fourKeyItems: {
      type: Boolean,
      required: false,
      default: false
    }
    // one-line-mode
    // listing-compact-mode
  },

  data() {
    return {};
  },

  computed: {
    isDefaultMode() {
      return this.mode.includes('default');
    },
    isListingCompactMode() {
      return this.mode.includes('listing-compact-mode');
    },
    isOneLineMode() {
      return this.mode.includes('one-line-mode');
    },
    isVerticalMode() {
      return this.mode.includes('vertical-mode');
    },
    isVerticalComparisonMode() {
      return this.mode.includes('vertical-comparison-mode');
    },
    isDetailPageMode() {
      return this.mode.includes('detail-page-mode')
    }
  },
};
